<template>
  <div class="Guide">
    <!-- <Banner tit1="报考须知" tit2="Application Guide" url="1"></Banner> -->
    <img src="../../assets/image/guide/banner2.jpg" alt="" style="width:100%" />
    <div class="Notice" style="margin-top:-10px">
      <h4>报考须知</h4>
      <el-card class="box_card text-center">
        <h4>报考条件：</h4>
        <p>
          1.考生需满18周岁； <br />2.报考者必须拥有中专以上学历；
          <br />3.考生应可以熟练的使用普通话；
        </p>
        <h4>适合报考人群：</h4>
        <p>
          1.想掌握来访者常见问题的解决方案和思路，金融、保险行业从业者员；
          <br />2.想成为生涯规划咨询师的人士； <br />3.企业中高层管理者;
          <br />4.HR、猎头从业人员; <br />5.地产、保险、理财等高客单价行业顾问
          <br />6.心理咨询师等定制化咨询服务行业从业人员
          <br />7.高校老师、就业辅导导师、高校导员;
          <br />8.中学授课老师、中学班主任;
          <br />9.留学、营地教育、背景提升、学业规划、高考志愿规划师等学生教育领域的老师、班主任、负责人等;
        </p>
        <h4>学习及报考费用：</h4>
        <p>
          1.费用含在线课程教学、考试、证书、配套软件平台VIP账户、线下辅导等，总计
          {{ this.$price }};
          <br />2.费用为一次性付费，付费完成后不可退款，可申请开具正规发票;
          <br />3. 付费完成后学员可获得无限次课程学习机会。
        </p>
      </el-card>
    </div>

    <div class="mode">
      <h4>报考方式：</h4>
      <el-card class="box_card">
        <div v-for="item in methods" :key="item.name">
          <div class="methods text-center">
            <img class="icon" :src="item.url" alt srcset /><span>{{
              item.name
              }}</span>
            <div>
              <p v-html="item.cont"></p>
            </div>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
  import Banner from './layout/Banner'
  export default {
    data() {
      return {
        methods: [
          {
            name: '在线报名',
            url: require('../../assets/image/guide/icon1.png'),
            cont:
              '1. 考生报名需在线注册并前往个人中心完善本人真实资料（请如实填写真实信息，以免影响证书生成及发放！）；<br/> 2.考生在缴费并完成线上或线下课程后即可在正式评测开放时间内进行考试，考试时间请留意公告。',
          },
          {
            name: '在线评测',
            url: require('../../assets/image/guide/icon2.png'),

            cont: `
         1.考试采用在线答题闭卷形式，试题类型分为两种种类型（单选题、多选题），总计50道题目，请考生认真审题；<br/> 2.考试时长为两个小时，答题过程中不得以任何方式向第三方求助，且不可中途离场。
          `,
          },
          {
            name: '获得证书、颁证条件',
            url: require('../../assets/image/guide/icon4.png'),
            cont: `
          1.生涯规划师测评考试总分为100分，80分以上即为通过此次考试并获得生涯规划师证书；<br/>
          2.考生在评测完成后请耐心等待，考试成绩在个人中心可以查询，电子证书每月月末签发；<br/>
          3.纸质证书会在制作完成后根据考生填写的地址快递发出，请学员注意短信通知，及时查看物流信息。
            `,
          },
          {
            name: '补考规则',
            url: require('../../assets/image/guide/icon3.png'),
            cont: `
          1.报考者拥有一次补考机会，在评测结果出来后，不达标的需要在后续的考试开放时间内重新考试；<br/>
          2.补考请在一个月内完成，过期平台将清除补考机会！
            `,
          },
        ],
      }
    },
    components: {
      Banner,
    },
  }
</script>
<style lang="less" scoped>
  .Guide {
    h2 {
      font-size: 26px;
      font-weight: bold;
      color: #000005;
      text-align: center;
    }

    h4 {
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      margin: 15px 0px;
    }

    p {
      font-size: 14px;
      font-weight: 400;
      color: #666;
      line-height: 20px;
    }

    .box_card {
      width: 80vw;
      margin: 20px auto;
      padding: 10px 20px;

      div {
        max-width: 60vw;
        margin: 0px auto;
      }

      p {
        text-align: left;
      }
    }

    .Notice {
      padding: 20px 0px;
      width: 100%;
      background-color: #fff6f2;

      /deep/.el-card__body {
        padding: 0px !important;
      }
    }

    .mode {
      padding: 20px 0px;

      /deep/.el-card__body {
        padding: 10px !important;
      }

      img {
        width: 50px;
        height: 50px;
      }
    }
  }

  .icon {
    vertical-align: middle;
  }

  .methods {
    span {
      font-weight: 800;
      color: #fd4a29;
      font-size: 18px;
    }
  }
</style>